import { styled } from '@uhg-abyss/web/tools/styled';
export const ModalSubTitle = styled('div', {
  fontSize: '18px',
  fontWeight: '400',
  lineHeight: '24px',
  color: '$core.color.neutral.80',
  marginBottom: '20px !important',
});

export const wrapperSelectedStyle = {
  border: '3px solid #002677',
};

export const cardsContainerStyle = {
  overflowY: 'auto',
  overflowX: 'hidden',
  position: 'relative',
  '&::-webkit-scrollbar': {
    width: '8px',
    right: '0',
    top: '0',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#929496',
    borderRadius: '4px',
    height: '50%',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '$core.color.neutral.60',
  },
  '& .location-cards-container': {
    width: '408px',
    marginRight: '0',
    paddingRight: '0',
    borderRadius: '8px',
    '@media (max-width: 464px)': {
      width: '96%',
    },
  },
};
